$(function () {
    var $headerNav = $('#header-nav');
    $headerNav.find(".full>.menu-item").each(function (index, menuItem) {
        var $topMenuItem = jQuery(menuItem);

        var $level1Container = $topMenuItem.find('.meganav-dropdown>.meganav-menu.meganav-level-1:first');
        var $level2Container = $topMenuItem.find('.meganav-dropdown>.meganav-menu.meganav-level-2:first');
        var $level3Container = $topMenuItem.find('.meganav-dropdown>.meganav-level-3:first');

        //var $imgContainer = $level3Container.find('.meganav-image');
        //var $level3Content = $level3Container.find('.meganav-level-3-content');
        //var $level3Title = $level3Container.find('.meganav-level-3-title');
        //var $level3Description = $level3Container.find('.meganav-level-3-description');
        //var $level3Button = $level3Container.find('.btn-default');

        //var hasLevel3 = $imgContainer.length || $level3Content.length || $level3Title.length || $level3Description.length || $level3Button.length;

        if (!$headerNav.length || !$level1Container.length || !$level2Container.length || !$level3Container.length) return;

        $level1Container.find(".dropdownmenu-item:first").addClass("active");
        displaySecondLevelItems($level1Container.find(".dropdownmenu-item:first"), $level2Container, $level3Container);


        $level1Container.find("li.dropdownmenu-item").hoverIntent(function () { setMenuContent(jQuery(this), $level3Container); } /*, function () { removeMenuContent(jQuery(this), $level3Container);}*/);

        $level1Container.find("li.dropdownmenu-item").hoverIntent(function () {
            var $currentDropdownItem = jQuery(this);
            if ($currentDropdownItem.hasClass("active")) return;

            $currentDropdownItem.siblings().removeClass("active");
            $currentDropdownItem.addClass("active");

            displaySecondLevelItems($currentDropdownItem, $level2Container, $level3Container);           
        }, function () { });

        if ($topMenuItem.hasClass("dropdown")) {
            var $meganavDropdown = $topMenuItem.find(".meganav-dropdown:first");
            $topMenuItem.hoverIntent(
                function () {
                    $meganavDropdown.addClass("active");
                    setMenuContent($level3Container, $level3Container);
                    $meganavDropdown.show(200);
                },
                function () {
                    $meganavDropdown.hide(200);
                    $meganavDropdown.removeClass("active");
                }
            );
        }

    });

    function displaySecondLevelItems($currentDropdownItem, $level2Container, $level3Container) {
        $level2Container.html("");
        var secondLevelItems = $currentDropdownItem.find(".meganav-menu.meganav-level-2:first").clone();
        secondLevelItems.removeClass("hidden");
        secondLevelItems.removeClass("meganav-level-2");
        secondLevelItems.removeClass("meganav-menu");
        $level2Container.append(secondLevelItems);
        secondLevelItems.hide(0);
        setTimeout(function () { secondLevelItems.show(200) });
        $level2Container.find("li.dropdown-item").hoverIntent(function () { setMenuContent(jQuery(this), $level3Container); });
//        $level2Container.find(".menu-link-with-dropdown").hoverIntent(function () { setMenuContent(jQuery(this), $level3Container); }, function () { removeMenuContent(jQuery(this), $level3Container); });
        //$level2Container.find(".menu-link-with-dropdown").hoverIntent(function () { setMenuBackgroundImage(jQuery(this), $level3Container); }, function () { removeMenuBackgroundImage(jQuery(this), $level3Container); });
    }

    function setMenuBackgroundImage($currentItem, $imgContainer) {        
        var newBg = $currentItem.data("dropdownimage");
        if (!newBg) return;

        var bg = $imgContainer.css('background-image');
        $imgContainer.data("tempbg", bg);
        $imgContainer.css('background-image', "url('" + newBg + "')");
    }

    function removeMenuBackgroundImage($currentItem, $imgContainer) {        
        var newBg = $currentItem.data("dropdownimage");
        if (!newBg) return;

        var tempbg = $imgContainer.data("tempbg");
        if (!tempbg) return;

        $imgContainer.css('background-image', tempbg);
    }


    function setMenuContent($currentItem, $menuContainer) {        
        var newBg = $currentItem.data("dropdownimage");
        var newTitle = $currentItem.data("dropdowntitle");
        var newDesc = $currentItem.data("dropdowndesc");
        var newButtonLink = $currentItem.data("dropdownbuttonlink");
        var newButtonLabel = $currentItem.data("dropdownbuttonlabel");
        var newContent = $currentItem.data("dropdowncontent");
        //if (!newBg) return;

        var $imgContainer = $menuContainer.find('.meganav-image');
        var $level3Content = $menuContainer.find('.meganav-level-3-content');
        var $level3Title = $menuContainer.find('.meganav-level-3-title');
        var $level3Description = $menuContainer.find('.meganav-level-3-description');
        var $level3Button = $menuContainer.find('.btn-default');

        var bg = $imgContainer.attr('src');
        $imgContainer.data("tempbg", bg);
        $imgContainer.attr('src', newBg);

        $level3Title.text(newTitle);
        $level3Description.text(newDesc);

        if (newButtonLink.length && newButtonLabel.length) {
            $level3Button.text(newButtonLabel);
            $level3Button.attr("href", newButtonLink);
            $level3Button.removeClass("hidden");
        } else {
            $level3Button.empty();
            $level3Button.attr("href", "");
            $level3Button.addClass("hidden");
        }

        if (newContent.length) {
            $level3Content.html(newContent);
            $level3Content.removeClass("hidden");

        } else {
            $level3Content.empty();
            $level3Content.addClass("hidden");
        }

    }

    function removeMenuContent($currentItem, $menuContainer) {

        var $imgContainer = $menuContainer.find('.meganav-image');
        var $level3Content = $menuContainer.find('.meganav-level-3-content');
        var $level3Title = $menuContainer.find('.meganav-level-3-title');
        var $level3Description = $menuContainer.find('.meganav-level-3-description');
        var $level3Button = $menuContainer.find('.btn-default');

        //var newBg = $currentItem.data("dropdownimage");
        //if (!newBg) return;

        //var tempbg = $imgContainer.data("tempbg");
        //if (!tempbg) return;

        var newBg = $menuContainer.data("dropdownimage");
        var newTitle = $menuContainer.data("dropdowntitle");
        var newDesc = $menuContainer.data("dropdowndesc");
        var newButtonLink = $menuContainer.data("dropdownbuttonlink");
        var newButtonLabel = $menuContainer.data("dropdownbuttonlabel");
        var newContent = $menuContainer.data("dropdowncontent");

        //$imgContainer.css('background-image', tempbg);

        $imgContainer.attr("src", newBg)
        $level3Title.text(newTitle);
        $level3Description.text(newDesc);

        if (newButtonLink.length && newButtonLabel.length) {
            $level3Button.text(newButtonLabel);
            $level3Button.attr("href", newButtonLink);
            $level3Button.removeClass("hidden");
        } else {
            $level3Button.empty();
            $level3Button.attr("href", "");
            $level3Button.addClass("hidden");
        }

        $level3Content.html(newContent);
    }

});



// WEBPACK FOOTER //
// ./cmsscripts/custom/mega-nav.js